import React from 'react';

import { ModalFooter } from './components/modal-footer/modal-footer';
import { PopoverModalWrapper } from './promo-video-popup-modal.styled';

type PromoVideoPopupProps = {
    onClick: () => void
    children: React.ReactNode
};

export function PromoVideoPopup ({
    onClick, children
}: PromoVideoPopupProps) {
    return (
        <PopoverModalWrapper>
            {children}
            <ModalFooter onClick={onClick} />
        </PopoverModalWrapper>
    );
}

